export default __webpack_public_path__ + "static/media/hospitala.192f9d7b.png";